import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { SteamVoucherCountrySelect } from '@features/country/select-country';
import { SteamVouchersList, useFilteredVoucherListByCountry } from '@features/voucher/list';
import { Text } from '@shared/ui/atoms';
import { SteamAccountVoucher, useCyberStore } from '@entities/tsp';
interface SteamVouchersProps {
  countryVouchers: {
    country: string;
    icon: string;
  }[];
  denominationsByCountry: Record<string, SteamAccountVoucher[]>;
}
const SteamVouchers: FC<SteamVouchersProps> = ({
  countryVouchers,
  denominationsByCountry
}) => {
  const {
    activeCountry
  } = useCyberStore();
  const vouchers = useFilteredVoucherListByCountry(denominationsByCountry, activeCountry);
  return <SteamVouchersWrapper id="steam-vouchers">
      <Text family="MTSWide" weight="black" size={{
      desktop: 'h4',
      mobile: 'h6'
    }} textTransform="uppercase">
        Подарочные карты steam
      </Text>
      <SelectWrapper>
        <SteamVoucherCountrySelect countryVouchers={countryVouchers} />
      </SelectWrapper>
      <SteamVouchersList vouchers={vouchers} countryVouchers={countryVouchers} />
    </SteamVouchersWrapper>;
};
export default SteamVouchers;
const SteamVouchersWrapper = /*#__PURE__*/styled('div')({
  name: "SteamVouchersWrapper",
  class: "s6ulu4z",
  propsAsIs: false
});
const SelectWrapper = /*#__PURE__*/styled('div')({
  name: "SelectWrapper",
  class: "sdhlxsg",
  propsAsIs: false
});

require("./SteamVouchers.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./SteamVouchers.tsx");